export const ADD_CONTACT = 'ADD_CONTACT'
export const ADD_FILES = 'ADD_FILES'
export const ADD_NOTE = 'ADD_NOTE'
export const REMOVE_FILE = 'REMOVE_FILE'
export const ADD_ALL_CONTACTS = 'ADD_ALL_CONTACTS'
export const SET_SELECTED_NOTE = 'SET_SELECTED_NOTE'
export const ADD_DATE = 'ADD_DATE'
export const RESET_FORM = 'RESET_FORM'
